<template>
  <div class="orthopedics-intro">
    <!-- 顶部导航 -->
    <header class="header">
      <h1 class="title">省级非遗 - 北张正骨术</h1>
      <p class="subtitle">湖湘中医正骨"南詹北张"两大流派之一</p>
    </header>
    
    <!-- 主内容区 -->
    <main class="container">
      <!-- 项目卡片 -->
      <section class="card" id="project">
        <div class="card-header">
          <h2 class="section-title">
            <i class="icon icon-project"></i>项目概述
          </h2>
        </div>
        <div class="card-content">
          <div class="flex-row">
            <div class="content-column">
              <p>中医正骨疗法（北张正骨术）2021年12月入选湖南省第五批传统中医类非物质文化遗产代表性项目名录扩展项目名录。</p>
              <p>北张正骨术是在湖南省株洲市本土成长发展起来的传统医学绝技，源于"宫廷正骨"，为我省中医正骨"南詹北张"两大流派之一。</p>
            </div>
            <div class="image-column">
               <img :src="require('@/assets/yyimages/zgzx.jpg')"  alt="中医正骨" class="main-image">
            </div>
          </div>
        </div>
      </section>
      
      <!-- 历史沿革 -->
      <section class="card" id="history">
        <div class="card-header">
          <h2 class="section-title">
            <i class="icon icon-history"></i>历史沿革
          </h2>
        </div>
        <div class="card-content">
          <div class="timeline">
            <div class="timeline-item" v-for="item in historyItems" :key="item.year">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <h3 class="timeline-year">{{ item.year }}</h3>
                <p>{{ item.content }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <!-- 地理分布 -->
      <section class="card" id="distribution">
        <div class="card-header">
          <h2 class="section-title">
            <i class="icon icon-map"></i>地理分布
          </h2>
        </div>
        <div class="card-content">
          <p>发源地：株洲市芦淞区白关镇原姚家坝乡</p>
          <p>主要传承基地：株洲市芦淞区中医骨伤专科医院、湖南省中医院、株洲市中医伤科医院</p>
          <p>应用范围：长沙市、浏阳市、株洲市、醴陵市等地医院的中医骨伤科</p>
          <p>国际影响：理论实践书籍被翻译成多国文字，风行印尼、新加坡等东南亚国家</p>
          
          <!-- 地图示意 -->
          <!-- <div class="map-container">
            <img src="https://picsum.photos/800/400?random=2" alt="地理分布" class="map-image">
          </div> -->
        </div>
      </section>
      
      <!-- 技术特色 -->
      <section class="card" id="features">
        <div class="card-header">
          <h2 class="section-title">
            <i class="icon icon-feature"></i>技术特色
          </h2>
        </div>
        <div class="card-content">
          <div class="feature-grid">
            <div class="feature-item" v-for="(item, index) in featureItems" :key="index">
              <div class="feature-icon" :class="item.iconClass"></div>
              <h3 class="feature-title">{{ item.title }}</h3>
              <p class="feature-desc">{{ item.desc }}</p>
            </div>
          </div>
          
          <!-- 手法展示 -->
          <div class="techniques">
            <h3 class="sub-title">正骨手法展示</h3>
            <div class="tech-image-container">
              <img 
                v-for="(img, index) in techniqueImgs" 
                :key="index" 
                :src="img" 
                alt="正骨手法" 
                class="tech-image"
                @mouseenter="enlargeImage(index)"
                @mouseleave="resetImage(index)"
              >
            </div>
          </div>
        </div>
      </section>
      
      <!-- 社会价值 -->
      <section class="card" id="value">
        <div class="card-header">
          <h2 class="section-title">
            <i class="icon icon-value"></i>社会功能与遗产价值
          </h2>
        </div>
        <div class="card-content">
          <div class="value-tabs">
            <div class="tab" v-for="(tab, index) in valueTabs" :key="index" @click="activeTab = index">
              <div :class="['tab-title', { active: activeTab === index }]">
                {{ tab.title }}
              </div>
              <div v-if="activeTab === index" class="tab-content">
                <p v-for="(item, i) in tab.content" :key="i" class="tab-paragraph">{{ item }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <!-- 保护情况 -->
      <section class="card" id="protection">
        <div class="card-header">
          <h2 class="section-title">
            <i class="icon icon-protection"></i>现有保护情况
          </h2>
        </div>
        <div class="card-content">
          <div class="protection-grid">
            <div class="protection-item" v-for="item in protectionItems" :key="item.title">
              <div class="protection-icon"></div>
              <h3 class="protection-title">{{ item.title }}</h3>
              <p class="protection-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </section>
    </main>
    
    <!-- 页脚 -->
    <footer class="footer">
      <p>省级非物质文化遗产 - 北张正骨术 © 2023 传承保护</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'OrthopedicsIntroduction',
  data() {
    return {
      // 历史沿革数据
      historyItems: [
        { year: '1763年', content: '清朝乾隆二十八年，张氏先祖张光靖坠马骨折，拜告老还乡的太医殷发祥为师，尽得真传，形成北张正骨绝技' },
        { year: '民国38年', content: '第五代传人张紫庚赴长沙高井街挂牌营业，北张正骨正式走出株洲，享誉湖湘，时任湖南省政府主席程潜亲授"今之华佗"牌匾' },
        { year: '1954年', content: '张紫庚领衔组建"湘一伤科联合诊所"，成为长沙市中医院的前身' },
        { year: '2000年后', content: '第七代传人张进等逐步成为骨科学科带头人，北张正骨跻身为湖南中医骨伤最重要的学术流派之一' },
        { year: '至今', content: '第八代传人钟继华、张旭等长期扎根发源地为民服务，年接诊患者超万余人次' }
      ],
      
      // 技术特色数据
      featureItems: [
        { 
          title: '核心观念', 
          desc: '解救疾苦，尊师重教，一半济世，一半糊口，代代相传，济世为民',
          iconClass: 'icon-concept'
        },
        { 
          title: '技术知识', 
          desc: '识体辩形，察形摸骨，临证整复，手随心转，夹外缚重手法，药用三期，康复练功',
          iconClass: 'icon-knowledge'
        },
        { 
          title: '外治法特点', 
          desc: '以中医正骨手法对各类骨折及关节脱位进行保守治疗，手法以轻、巧、快、准为特点，痛苦小，费用低，接近零创伤，康复快',
          iconClass: 'icon-treatment'
        },
        { 
          title: '内治法特色', 
          desc: '配合祖传接骨散、伤痛水等八大制剂，针对骨伤初期、中期、晚期三期用药，达到接骨续筋、舒筋活血等功效',
          iconClass: 'icon-medicine'
        }
      ],
      
      // 正骨手法图片
      techniqueImgs: [
        require('@/assets/yyimages/正骨.jpg'),
        require('@/assets/yyimages/正骨2.jpg'),
        require('@/assets/yyimages/正骨3.jpg'),
        require('@/assets/yyimages/正骨4.jpg'),
        require('@/assets/yyimages/正骨5.jpg')
      ],
      
      // 社会价值标签
      valueTabs: [
        { 
          title: '社会功能', 
          content: [
            '广泛用于临床，为骨伤患者解除痛苦，提供自然安全的治疗选择，减轻医疗费用',
            '具有重要的文化传承与教育功能，通过师徒传承培养优秀正骨医师，普及中医知识'
          ]
        },
        { 
          title: '科学价值', 
          content: [
            '近300年医疗实践总结的绝技，成为现代医疗技术不可分割的部分',
            '不开刀的闭合治疗和特色中药制剂，在临床上广泛运用，有效低廉的诊疗技术缓解群众治病压力'
          ]
        },
        { 
          title: '文化价值', 
          content: [
            '与湖湘文化"心忧天下、百折不挠、敢为人先、兼容并蓄"的思想一脉相承',
            '主张济世为民、精益求精，保存完整的传统医学技术与传承体系，展现株洲中医文化发展历程'
          ]
        },
        { 
          title: '社会价值', 
          content: [
            '发源地年接诊骨伤患者上万人次，70%以上采取北张正骨术手法治疗，见效快、无创伤、价格低廉',
            '湖南省中医院等传承基地广泛运用于临床，提供安全有效的医疗服务'
          ]
        }
      ],
      
      // 保护情况数据
      protectionItems: [
        { 
          title: '展示阵地建设', 
          desc: '投入40多万元打造北张正骨文化展示馆、传承创新工作室、传承治疗室"一馆两室"，兼具博物、收藏、展示、研究等多功能' 
        },
        { 
          title: '传承团队组建', 
          desc: '以省非代表性传承人张进为领衔人，组建涵盖老、中、青3个传承梯队的10人传承团队' 
        },
        { 
          title: '推广发扬', 
          desc: '制作院徽，开通微信公众号宣传，开展进机关、进社区、进企业等义诊活动，让北张正骨服务人民群众' 
        },
        { 
          title: '临床应用', 
          desc: '开设正骨科、筋伤科2个新科室，以及2个北张正骨示范门诊，以传统手法和用药为主治疗病人' 
        }
      ],
      
      // 图片放大状态
      enlargedImages: [false, false, false],
      
      // 激活的标签页
      activeTab: 0
    }
  },
  methods: {
    // 图片放大效果
    enlargeImage(index) {
      this.enlargedImages[index] = true;
    },
    resetImage(index) {
      this.enlargedImages[index] = false;
    },
    
    // 页面滚动时添加动画效果
    addScrollAnimation() {
      const cards = document.querySelectorAll('.card');
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1
      });
      
      cards.forEach(card => {
        observer.observe(card);
      });
    }
  },
  mounted() {
    // 页面滚动时添加动画效果
    this.addScrollAnimation();
  }
}
</script>

<style scoped>
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", sans-serif;
}

body {
  background-color: #f9f7f3;
  color: #333;
  line-height: 1.6;
}

.orthopedics-intro {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* 头部样式 */
.header {
  text-align: center;
  padding: 40px 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 30px;
}

.title {
  font-size: 2.5rem;
  color: #4a6d59;
  margin-bottom: 10px;
  font-weight: 700;
}

.subtitle {
  font-size: 1.2rem;
  color: #6c8a7c;
  font-style: italic;
}

/* 容器样式 */
.container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 30px;
}

/* 卡片样式 */
.card {
  margin-bottom: 30px;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.card-header {
  background-color: #e9f2ee;
  padding: 15px 20px;
  border-bottom: 1px solid #d4e0d8;
}

.section-title {
  font-size: 1.8rem;
  color: #4a6d59;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-title i {
  font-size: 1.2rem;
  color: #82a392;
}

.card-content {
  padding: 20px;
}

/* 历史沿革时间线 */
.timeline {
  position: relative;
  padding-left: 30px;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 2px;
  background-color: #d4e0d8;
}

.timeline-item {
  position: relative;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px dashed #e1e8e4;
}

.timeline-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.timeline-dot {
  position: absolute;
  left: -16px;
  top: 8px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #82a392;
  border: 3px solid #e9f2ee;
}

.timeline-year {
  font-size: 1.1rem;
  color: #4a6d59;
  font-weight: 600;
  margin-bottom: 5px;
}

/* 布局样式 */
.flex-row {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  align-items: flex-start;
}

.content-column {
  flex: 1;
  min-width: 300px;
}

.image-column {
  flex: 1;
  min-width: 300px;
  display: flex;
  justify-content: center;
}

.main-image {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 特色网格 */
.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.feature-item {
  background-color: #f9f7f3;
  padding: 20px;
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
}

.feature-icon {
  width: 50px;
  height: 50px;
  background-color: #d4e0d8;
  border-radius: 50%;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #4a6d59;
}

.icon-concept {
  background-color: #e6f0eb;
}

.icon-knowledge {
  background-color: #d9e8e0;
}

.icon-treatment {
  background-color: #c8e0d4;
}

.icon-medicine {
  background-color: #b7d8c8;
}

.feature-title {
  font-size: 1.2rem;
  color: #4a6d59;
  margin-bottom: 10px;
}

.feature-desc {
  color: #666;
  font-size: 0.95rem;
}

/* 手法图片 */
.techniques {
  margin-top: 30px;
}

.sub-title {
  font-size: 1.3rem;
  color: #4a6d59;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #d4e0d8;
}

.tech-image-container {
  display: flex;
  gap: 15px;
  overflow-x: auto;
  padding: 10px 0;
}

.tech-image {
  width: 200px;
  height: 130px;
  object-fit: cover;
  border-radius: 6px;
  transition: transform 0.3s ease;
}

.tech-image:hover, .tech-image.active {
  transform: scale(1.1);
  z-index: 10;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

/* 标签页样式 */
.value-tabs {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.tab {
  background-color: #f9f7f3;
  border-radius: 8px;
  overflow: hidden;
}

.tab-title {
  padding: 15px 20px;
  font-size: 1.1rem;
  color: #4a6d59;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.tab-title.active {
  background-color: #e9f2ee;
  color: #3a5c49;
  border-bottom: 2px solid #82a392;
}

.tab-content {
  padding: 20px;
  color: #666;
  font-size: 0.95rem;
}

.tab-paragraph {
  margin-bottom: 10px;
  line-height: 1.7;
}

/* 保护情况网格 */
.protection-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.protection-item {
  background-color: #f9f7f3;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

.protection-icon {
  width: 60px;
  height: 60px;
  background-color: #d4e0d8;
  border-radius: 50%;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  color: #4a6d59;
  align-self: center;
}

.protection-title {
  font-size: 1.2rem;
  color: #4a6d59;
  text-align: center;
  margin-bottom: 10px;
}

.protection-desc {
  color: #666;
  font-size: 0.95rem;
  text-align: center;
}

/* 地图容器 */
.map-container {
  margin-top: 20px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.map-image {
  width: 100%;
  height: auto;
  display: block;
}

/* 页脚样式 */
.footer {
  text-align: center;
  padding: 20px;
  color: #666;
  font-size: 0.9rem;
  margin-top: 30px;
}

/* 动画效果 */
.fade-in {
  animation: fadeIn 0.8s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .title {
    font-size: 2rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
  
  .container {
    padding: 20px 15px;
  }
  
  .card-content {
    padding: 15px;
  }
  
  .feature-grid, .protection-grid {
    grid-template-columns: 1fr;
  }
  
  .flex-row {
    flex-direction: column;
  }
  
  .section-title {
    font-size: 1.5rem;
  }
}
</style>